module.exports = __webpack_public_path__ + "static/media/mobile-app-development-icon.f2e07055.svg";